<template>
  <div class="grid gap-2">
    <transition-group name="fade-slide" tag="div" class="grid gap-2">
      <div
        v-for="(item, index) in useUtils.isMessage"
        :key="index"
        role="alert"
        :class="[
          'alert alert-soft alert-vertical sm:alert-horizontal min-w-50 max-w-72 overflow-hidden',
          item.status == 'true' ? 'alert-success' : 'alert-error',
        ]"
      >
        <IconLucide
          v-if="item.status == 'true'"
          name="Bell"
          class="h-6 w-6 shrink-0 stroke-success"
        />
        <IconLucide v-else name="CircleAlert" class="h-6 w-6 shrink-0 stroke-error" />
        <span class="truncate max-w-48">{{ item.message }}</span>
        <button
          type="button"
          class="btn btn-ghost btn-square btn-xs"
          @click="useUtils.toogleCloaseAlert(index)"
        >
          <IconLucide name="X" class="w-5" />
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script lang="ts">
import IconLucide from '@/components/icons/IconLucide.vue'
import { useUtilsStore } from '@/stores'

export default {
  components: { IconLucide },
  setup() {
    const useUtils = useUtilsStore()
    return { useUtils }
  },
}
</script>

<style></style>
